import { post } from '@eika-infrastruktur/request';

import { Skademeldingstype, SporsmalsflytSkademeldingDTO } from '../../types/generated-types';
import { Bonus, Egenandel, MaksKjorelengde } from '../../types/internal-types';
import { hentBonusUrl, hentEgenandelUrl, hentKjorelengdelUrl } from '../../urler';
import { getRequestOptions } from '../reducer/skademelding-actions';

export const getBonus = async (
    forsikringsnummer: string,
    forsikringsversjon: number,
    skadetype: Skademeldingstype,
    bankregnr: string,
    skademelding: SporsmalsflytSkademeldingDTO,
): Promise<Bonus> => {
    return post<Bonus>(
        hentBonusUrl(forsikringsnummer, forsikringsversjon, skadetype),
        skademelding,
        getRequestOptions(bankregnr),
    );
};

export const getEgenandel = async (
    forsikringsnummer: string,
    bankregnr: string,
    skademelding: SporsmalsflytSkademeldingDTO,
): Promise<Egenandel> =>
    post<Egenandel>(hentEgenandelUrl(forsikringsnummer), skademelding, getRequestOptions(bankregnr));

export const getMaksKjorelengde = async (
    forsikringsnummer: string,
    forsikringsversjon: number,
    bankregnr: string,
    skademelding: SporsmalsflytSkademeldingDTO,
): Promise<MaksKjorelengde> => {
    return post<MaksKjorelengde>(
        `${hentKjorelengdelUrl(forsikringsnummer, forsikringsversjon)}`,
        skademelding,
        getRequestOptions(bankregnr),
    );
};
